<template>
    <checkout-popup-layout :open="true">
        <checkout-step-one v-show="false"></checkout-step-one>
        <checkout-step-two :standalone="true" v-show="showStepTwo" :is-lifetime-updates="true"></checkout-step-two>
        <checkout-step-three :standalone="true" v-show="!showStepTwo"></checkout-step-three>
    </checkout-popup-layout>
</template>

<script>
import CheckoutPopupLayout from './CheckoutPopupLayout.vue';
import CheckoutStepOne from './CheckoutStepOne.vue';
import CheckoutStepTwo from './CheckoutStepTwo.vue';
import CheckoutStepThree from './CheckoutStepThree.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CheckoutPopupLayout,
        CheckoutStepOne,
        CheckoutStepTwo,
        CheckoutStepThree,
    },

    computed: {
        ...mapState([
            'popup',
        ]),
        showStepTwo() {
            return this.popup.step === 2;
        }
    },
    mounted() {
        this.$store.commit('setLifetimeUpdates', {
            standalone: true,
        });
    }
};
</script>
